'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeaderboardItem = function LeaderboardItem(_ref) {
  var amount = _ref.amount,
      amountLabel = _ref.amountLabel,
      classNames = _ref.classNames,
      href = _ref.href,
      image = _ref.image,
      LinkTag = _ref.linkTag,
      linkProps = _ref.linkProps,
      rank = _ref.rank,
      subtitle = _ref.subtitle,
      target = _ref.target,
      title = _ref.title,
      Tag = _ref.tag;

  var _useState = (0, _react.useState)((0, _v2.default)()),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  return _react2.default.createElement(
    Tag,
    { className: 'c11n-leaderboard-item ' + classNames.root },
    _react2.default.createElement(
      LinkTag,
      _extends({
        className: classNames.link,
        'aria-describedby': id + '-rank ' + id + '-title ' + id + '-subtitle ' + id + '-amount',
        id: id,
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener' : undefined
      }, linkProps),
      rank && _react2.default.createElement(
        'div',
        {
          'aria-hidden': true,
          id: id + '-rank',
          htmlFor: id,
          className: classNames.rank
        },
        rank
      ),
      image && _react2.default.createElement('img', {
        src: image,
        alt: title,
        'aria-hidden': true,
        className: classNames.image
      }),
      _react2.default.createElement(
        'div',
        { className: classNames.info },
        _react2.default.createElement(
          'div',
          {
            'aria-hidden': true,
            id: id + '-title',
            htmlFor: id,
            className: classNames.title
          },
          title
        ),
        subtitle && _react2.default.createElement(
          'div',
          {
            'aria-hidden': true,
            id: id + '-subtitle',
            htmlFor: id,
            className: classNames.subtitle
          },
          subtitle
        )
      ),
      amount && _react2.default.createElement(
        'div',
        {
          'aria-hidden': true,
          'aria-label': amountLabel,
          id: id + '-amount',
          htmlFor: id,
          className: classNames.amount
        },
        amount
      )
    )
  );
};

LeaderboardItem.propTypes = {
  /**
   * The background color of the section
   */
  background: _propTypes2.default.string,

  /**
   * The color of the text
   */
  foreground: _propTypes2.default.string,

  /**
   * The color of the border
   */
  borderColor: _propTypes2.default.string,

  /**
   * The width of the border
   */
  borderWidth: _propTypes2.default.number,

  /**
   * The radius of the section
   */
  radius: _propTypes2.default.string,

  /**
   * The margin to be applied
   */
  margin: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),

  /**
   * The tag or component to be used for the root element
   */
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),

  /**
   * The tag or component to be used as the link. e.g. `a`, React Router `Link`
   */
  linkTag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),

  /**
   * Props to be applied to the linkTag
   */
  linkProps: _propTypes2.default.object,

  /**
   * The url of the leader's page. Passed to linkTag as `href` prop
   */
  href: _propTypes2.default.string,

  /**
   * The target for the link. e.g. `_blank`
   */
  target: _propTypes2.default.string,

  /**
   * The avatar for the leader
   */
  image: _propTypes2.default.string,

  /**
   * The name or title of the leader
   */
  title: _propTypes2.default.string.isRequired,

  /**
   * The charity or subtitle of the leader
   */
  subtitle: _propTypes2.default.string,

  /**
   * The rank of the leader (optional)
   */
  rank: _propTypes2.default.number,

  /**
   * The amount being ranked by
   */
  amount: _propTypes2.default.string,

  /**
   * The aria-label for the amount e.g. 11 miles for an amount of 11 mi.
   */
  amountLabel: _propTypes2.default.string,

  /**
   * The custom styles to be applied
   */
  styles: _propTypes2.default.object
};

LeaderboardItem.defaultProps = {
  avatarRadius: 'large',
  borderColor: 'shade',
  href: '#',
  linkTag: 'a',
  margin: 0,
  radius: 'medium',
  spacing: 0.5,
  styles: {},
  tag: 'li',
  target: '_blank'
};

exports.default = (0, _withStyles2.default)(_styles2.default)(LeaderboardItem);